<template>
<el-dialog width="40%" title="追加规则" :visible.sync="visible" :close-on-click-modal="false" append-to-body>
    <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="100px">
        <el-form-item label="标题" prop="label">
            <el-input v-model="ruleForm.label" clearable></el-input>
        </el-form-item>
        <el-form-item label="字段" prop="field">
            <el-input v-model="ruleForm.field" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择类型" clearable>
                <el-option v-for="(item,index) in former.types" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="附加值" prop="content" v-if="['select','range','checkbox','radio'].includes(ruleForm.type)">
            <el-button type="warning" @click="addAddonItem(addons.length)">追加</el-button>
            <div class="h10"></div>
            <el-row :gutter="8" v-for="(item,index) in addons" :key="index">
                <el-col :span="8">
                    <el-input v-model="addons[index]['value']" type="text" placeholder="值"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-input v-model="addons[index]['label']" type="text" placeholder="文本"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-button type="warning" @click="addAddonItem(index)">前插</el-button>
                    <el-button type="danger" @click="removeAddonItem(index)">删除</el-button>
                </el-col>
            </el-row>
        </el-form-item>
        <!-- <el-form-item label="附加值" prop="content" v-if="['select','range','checkbox','radio'].includes(ruleForm.type)">
            <el-input type="textarea" v-model="ruleForm.content"></el-input>
            <p>下拉框、多选框、单选框示例:"1:名称1|2:名称2"; 区间示例:"1-8"或"8"</p>
        </el-form-item> -->
        <el-form-item label="参与底价计算" prop="calc">
            <el-radio-group v-model="ruleForm.calc">
                <el-radio label="1">参与</el-radio>
                <el-radio label="0">不参与</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
import former from '@/utils/former.js'

const ruleForm = {
    label: "",
    field: "",
    type: "",
    content: "",
    calc: '0'
};

export default {
    props: {
        parent: {}
    },
    data() {
        return {
            visible: false,
            position: 0,
            ruleForm: Object.assign({}, ruleForm),
            rules: {
                label: [{
                    required: true,
                    message: '请输入标题',
                    trigger: 'blur'
                }],
                field: [{
                    required: true,
                    message: '请输入字段',
                    trigger: 'blur'
                }],
                type: [{
                    required: true,
                    message: '请选择类型',
                    trigger: 'change'
                }],
            },
            addons: []
        }
    },
    beforeCreate() {
        this.former = former;
    },
    methods: {
        showDialog(position) {
            this.visible = true;
            this.position = position;
            this.addons = [];
        },
        addAddonItem(position) {
            let item = {
                value: position + 1,
                label: '',
            };
            if (position == this.addons) {
                this.addons.push(item);
            } else {
                let arr1 = this.addons.slice(0, position);
                arr1.push(item);
                let arr2 = this.addons.slice(position);
                this.addons = arr1.concat(arr2);
            }
        },
        removeAddonItem(index) {
            this.$confirm('确定删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.addons.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let addons = _this.addons.map(ele => ele.value + ':' + ele.label);
                    
                    _this.ruleForm.content = addons.join("|");
                    _this.parent.appendAttr(_this.ruleForm, this.position);
                    _this.visible = false;
                    _this.ruleForm = Object.assign({}, ruleForm);
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>
<style scoped>
.h10 {
    height: 10px;
}
</style>